import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Row, Col, Container } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import classes from "./CoachFiltersModal.module.css";

import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { TimeOfTheDay } from "../../../../../stories/TimeOfTheDay/TimeOfTheDay";
import { AveragePriceRangePicker } from "../../../../../stories/AveragePriceRangePicker/AveragePriceRangePicker";
import { DistanceRangePicker } from "../../../../../stories/DistanceRangePicker/DistanceRangePicker";
import SavedFilterModal from "../SavedFilterModal/SavedFilterModal";
import { Radio } from "../../../../../stories/Radio/Radio";

const CoachFiltesrModal = ({ show, setShow }) => {
  const [forehandState, setForehandState] = useState([]);
  const [backhandState, setBackhandState] = useState([]);
  const [topSpinState, setTopSpinState] = useState([]);
  const [serveState, setServeState] = useState([]);

  const [beginnerState, setBeginnerState] = useState([]);
  const [intermediateState, setIntermediateState] = useState([]);
  const [competitiveState, setCompetitiveState] = useState([]);
  const [advancedState, setAdvancedState] = useState([]);

  const [kidsState, setKidsState] = useState([]);
  const [juniorsState, setJuniorsState] = useState([]);
  const [adultsState, setAdultsState] = useState([]);
  const [seniorsState, setSeniorsState] = useState([]);

  // Filter States
  const [minAndMaxPrice, setMinAndMaxPrice] = useState([0, 10])
  const [distanceRange, setDistanceRange] = useState(0)
  const [gender, setGender] = useState('')

  const [isSaveFilters, setIsSaveFilter] = useState(false);

  const tagsDataArr = [
    {
      tag_name: "Forehand",
      count: 14,
      state: forehandState,
      setState: setForehandState,
    },
    {
      tag_name: "Backhand",
      count: 72,
      state: backhandState,
      setState: setBackhandState,
    },
    {
      tag_name: "TopSpin",
      count: 383,
      state: topSpinState,
      setState: setTopSpinState,
    },
    {
      tag_name: "Serve",
      count: 617,
      state: serveState,
      setState: setServeState,
    },
  ];

  const skillLevelDataArr = [
    {
      tag_name: "Beginner",
      state: beginnerState,
      setState: setBeginnerState,
    },
    {
      tag_name: "Intermediate",
      state: intermediateState,
      setState: setIntermediateState,
    },
    {
      tag_name: "Competitive",
      state: competitiveState,
      setState: setCompetitiveState,
    },
    {
      tag_name: "Advanced",
      state: advancedState,
      setState: setAdvancedState,
    },
  ];

  const averageLevelDataArr = [
    {
      tag_name: "Kids",
      state: kidsState,
      setState: setKidsState,
    },
    {
      tag_name: "Juniors",
      state: juniorsState,
      setState: setJuniorsState,
    },
    {
      tag_name: "Adults",
      state: adultsState,
      setState: setAdultsState,
    },
    {
      tag_name: "Seniors",
      state: seniorsState,
      setState: setSeniorsState,
    },
  ];
  const genderOptions = [
    { label: 'Any' },
    { label: 'Female' },
    { label: 'Male' },
    { label: 'Other' },
  ]

  return (
    <>
      <style>{`
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal-body {
          padding: 0px !important;
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
        footer={
          <div className={classes.dFlexJustifyContentSpaceBetPaddInl24}>
            <LinkButtonWithIcon text={"Clear all"} />
            <Button
              primary={"true"}
              label={"Apply"}
              customStyle={{ padding: "12px 55.5px", width: "156px" }}
            />
          </div>
        }
      >
        <div className={classes.content}>
          <Container
            fluid
            className={["p-0", classes.chattingContainer].join(" ")}
          >
            <div
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[classes.ChatHeader].join(" ")}
            >
              <div
                className={[
                  classes.dflex,
                  classes.itemscenter,
                  classes.w100,
                ].join(" ")}
              >
                <ReactSVG
                  src={CancelIconBlack}
                  onClick={() => setShow(false)}
                />
                <div
                  className={[
                    classes.dFlexJustifyContentCenter,
                    classes.mr16,
                    classes.w100,
                  ].join(" ")}
                >
                  <p
                    style={{
                      ...Fonts.b3,
                      color: Colors.neutralShadesOfNero,
                      lineHeight: "14px",
                      lineHeight: "20px",
                    }}
                    className={[classes.pl16].join(" ")}
                  >
                    Filters
                  </p>
                </div>
                <ReactSVG
                  src={BookmarkIconBlack}
                  onClick={() => setIsSaveFilter(true)}
                />
              </div>
            </div>
          </Container>
          <Row className="g-0">
            <div className={classes.paddingInline24}>
              <div>
                <h1
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                    marginTop: 80,
                  }}
                >
                  Focus tags
                </h1>
                <div>
                  {tagsDataArr?.map((item, index) => (
                    <div
                      key={index}
                      className={
                        classes.dFlexAlignItemsCenterJustifyContentSpaceBetween
                      }
                    >
                      <div className={classes.dFlexAlignItemsCenter}>
                        <Checkbox
                          setValue={item?.setState}
                          value={item?.state}
                          label={item?.tag_name}
                        />
                        <div
                          className={classes.countCircle} style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}>
                          <p style={{ ...Fonts.otherMedium, color: Colors.neutralShadesOfDimGray, fontFamily: 'inter-400' }}>{item?.count}</p>
                        </div>
                      </div>
                      <p>Tennis</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <hr className={classes.marginBlock20} />

            <div className={classes.dNone}>
              {/* Ramiz Comp Start */}

              <div className={classes.pLR16}>
                <h5 style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}>Price range</h5>
                <AveragePriceRangePicker
                  showButtons={false}
                  containerClass={classes.containerComp}
                  setMinAndMaxPrice={setMinAndMaxPrice}
                  minAndMaxPrice={minAndMaxPrice}
                />
              </div>
              <hr className={classes.marginBlock20} />

              <div className={classes.pLR16}>
                <h5 style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}>Distance</h5>
                <DistanceRangePicker
                  showButtons={false}
                  containerClass={classes.containerComp}
                  value={distanceRange}
                  setValue={setDistanceRange}
                />
              </div>
              <hr className={classes.marginBlock20} />
              <div className={classes.pLR16}>
                <TimeOfTheDay
                  showButtons={false}
                  containerClass={classes.containerComp}
                />
              </div>

            </div>

            {/* Ramiz Comp end */}
            <hr className={classes.marginBlock20} />

            <div className={classes.paddingInline24}>
              <div>
                <h1
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Gender
                </h1>
                {genderOptions?.map((item, index) => (
                  <Radio
                    key={index}
                    setValue={setGender}
                    value={gender}
                    label={item?.label}
                  />
                ))}
              </div>
            </div>
            <hr className={classes.marginBlock20} />
            <div className={classes.paddingInline24}>
              <div>
                <h1
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Skill Level
                </h1>
                {skillLevelDataArr?.map((item, index) => (
                  <Checkbox
                    key={index}
                    setValue={item?.setState}
                    value={item?.state}
                    label={item?.tag_name}
                  />
                ))}
              </div>
            </div>
            <hr className={classes.marginBlock20} />
            <div className={classes.paddingInline24}>
              <div>
                <h1
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Average
                </h1>
                {averageLevelDataArr?.map((item, index) => (
                  <Checkbox
                    setValue={item?.setState}
                    value={item?.state}
                    label={item?.tag_name}
                  />
                ))}
              </div>
            </div>
          </Row>
        </div>
        {isSaveFilters && (
          <SavedFilterModal show={isSaveFilters} setShow={setIsSaveFilter} />
        )}
      </ModalSkeleton>
    </>
  );
};
export default CoachFiltesrModal;
